export default __webpack_public_path__ + "static/media/ASSETS-master.4224f656.png";